import React from 'react';
import Icon from '../../../components/AppIcon';

const MobileHeader = () => {
  return (
    <div className="lg:hidden bg-primary text-primary-foreground p-6 text-center">
      <div className="flex items-center justify-center space-x-3 mb-4">
        <div className="w-12 h-12 bg-primary-foreground/20 rounded-lg flex items-center justify-center">
          <Icon name="Briefcase" size={28} color="white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">ConsultFlow</h1>
          <p className="text-primary-foreground/80 font-medium">Pro</p>
        </div>
      </div>
      
      <p className="text-primary-foreground/90 text-sm">
        Gestão Completa de Consultorias
      </p>
      
      {/* Trust Indicators */}
      <div className="flex items-center justify-center space-x-6 mt-4 pt-4 border-t border-primary-foreground/20">
        <div className="flex items-center space-x-1">
          <Icon name="Shield" size={14} className="text-success" />
          <span className="text-xs">Seguro</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Award" size={14} className="text-success" />
          <span className="text-xs">ISO 9001</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="CheckCircle" size={14} className="text-success" />
          <span className="text-xs">CNPJ Ativo</span>
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;